import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import isEmpty from 'lodash/isEmpty';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../components/all_feed/all_feed';
import { authorAllFeedAllStoriesRendered } from '../../../../redux/action_creators/author_all_feed_action_creators';

/*
 import { canUseDOM } from 'exenv';
 if(canUseDOM) {
 debugger;
 }
 */

// eslint-disable-next-line react/prefer-stateless-function
class Author extends Component {
  render() {
    const { authorPage, author, config, authorAllFeed } = this.props;
    const isLoading = get(authorPage, 'isLoading');

    if (get(author, 'error') && !isLoading) {
      return (
        <section className="author-page">
          <article className="author-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (isLoading) {
      return (
        <section className="author-page">
          <article className="author-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(authorPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const authorName = get(author, 'name');
    const currentSite = get(config, 'site');
    const env = get(config, 'env');

    return (
      <section className="author-page">
        <section className="author-bio">
          {isEmpty(author)
            ? ''
            : <div className="author-bio__row">
                <div className="author-bio__stories-col">
                  <div className="author-bio__text-wrapper">
                    <h1 className="author-bio__author-name">{authorName}</h1>
                    <article
                      className="author-bio__author-desc"
                      dangerouslySetInnerHTML={{
                        __html: get(author, 'description')
                      }}
                    />
                  </div>
                </div>
                <div className="author-bio__ad-col">
                  <div>
                    <Ad
                      {...combinedAdModel}
                      noLazyLoad
                      pos="atf"
                      name="fixedrectangle"
                    />
                    <Ad
                      {...combinedAdModel}
                      noLazyLoad
                      pos="atf"
                      name="mobileparallax_1"
                    />
                  </div>
                </div>
              </div>}
        </section>

        <AllFeed
          adModel={combinedAdModel}
          stories={get(authorAllFeed, 'posts')}
          allRendered={get(authorAllFeed, 'allRendered')}
          updateAction={authorAllFeedAllStoriesRendered}
          currentSite={currentSite}
          env={env}
          mobileSeeMoreHidden
          authorPage
          author={author}
        />

        <div className="author-page__all-ad-container">
          <Ad {...combinedAdModel} pos="btf" name="flexiblebillboard_1" />
          <Ad {...combinedAdModel} pos="btf" name="mobileparallax_1" />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    authorAllFeed: {
      posts: get(state, 'authorAllFeed.data.posts') || [],
      allRendered: get(state, 'authorAllFeed.allRendered') || false
    },
    authorPage: state.authorPage || {
      ads: {
        baseConfig: {}
      }
    },
    author: get(state, 'author.data') || { error: true }
  };
}

Author.propTypes = {
  config: PropTypes.shape({}).isRequired,
  authorPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  author: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string
  }).isRequired,
  authorAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(Author));



// WEBPACK FOOTER //
// ./src/views/containers/pages/author_page/author_page.js